import React from 'react';
import './styles.css';

const WarningNotification = ({
    text,
    position = 'top-right',
    buttons = [],
    onClose,
    show = true
}) => {
    if (!show) return null;

    const getPositionClass = () => {
        switch (position) {
            case 'top-left':
                return 'warning-notification--top-left';
            case 'top-center':
                return 'warning-notification--top-center';
            case 'top-right':
                return 'warning-notification--top-right';
            case 'center':
                return 'warning-notification--center';
            default:
                return 'warning-notification--top-right';
        }
    };

    const handleButtonClick = (button) => {
        if (button.onClick && typeof button.onClick === 'function') {
            button.onClick();
        }
    };

    return (
        <div className={`warning-notification ${getPositionClass()}`}>
            <div className="warning-notification-content">
                {/* Header Section */}
                <div className="warning-notification-header">
                    <div className="warning-notification-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" fill="#FCD34D" />
                            <path 
                                d="M12 8V12M12 16H12.01" 
                                stroke="white" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    
                    <div className="warning-notification-text">
                        {text}
                    </div>
                    
                    {onClose && (
                        <button 
                            className="warning-notification-close"
                            onClick={onClose}
                            aria-label="Fechar notificação"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path 
                                    d="M18 6L6 18M6 6L18 18" 
                                    stroke="#FCD34D" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    )}
                </div>

                {/* Buttons Section */}
                {buttons.length > 0 && (
                    <div className="warning-notification-buttons">
                        {buttons.slice(0, 2).map((button, index) => (
                            <button
                                key={index}
                                className="warning-notification-button"
                                onClick={() => handleButtonClick(button)}
                            >
                                {button.icon && (
                                    <span className="warning-notification-button-icon">
                                        {button.icon}
                                    </span>
                                )}
                                <span className="warning-notification-button-text">
                                    {button.text}
                                </span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WarningNotification;
